module.exports = __webpack_public_path__ + "612405bc6d58acf8319762d5a6583ced.MP3";